function oxTrack(event, detail = {}) {
  const customerPrivacy = window.Shopify?.customerPrivacy;
  if (customerPrivacy?.analyticsProcessingAllowed && !customerPrivacy.analyticsProcessingAllowed()) return false;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...detail });
  window.dispatchEvent(new CustomEvent(event, { detail }));
  return true;
}

class OchilaGallery {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-gallery-slide]')];
    this.thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    this.current = root.querySelector('[data-gallery-current]');
    this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
    this.startX = null;
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.show(Number(thumb.dataset.galleryThumb), true));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.show(target, true);
      });
    });
    const viewport = root.querySelector('.ox-product-gallery__viewport');
    viewport?.addEventListener('pointerdown', (event) => { this.startX = event.clientX; });
    viewport?.addEventListener('pointerup', (event) => {
      if (this.startX === null) return;
      const distance = event.clientX - this.startX;
      this.startX = null;
      if (Math.abs(distance) > 45) this.show(this.index + (distance < 0 ? 1 : -1));
    });
  }

  show(nextIndex, focusThumb = false) {
    if (!this.slides.length) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    this.thumbs.forEach((thumb, index) => {
      const active = index === this.index;
      thumb.setAttribute('aria-selected', String(active));
      thumb.tabIndex = active ? 0 : -1;
    });
    if (this.current) this.current.textContent = String(this.index + 1);
    if (focusThumb) this.thumbs[this.index]?.focus();
    oxTrack('ox_gallery_view', { index: this.index + 1 });
  }
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-ox-variant-select]');
  if (!select) return;
  const section = select.closest('[data-ox-product-section]');
  const option = select.selectedOptions[0];
  if (!section || !option) return;

  section.querySelectorAll('[data-ox-variant-input]').forEach((input) => { input.value = option.value; });
  section.querySelectorAll('[data-ox-price]').forEach((node) => { node.textContent = option.dataset.price || ''; });
  section.querySelectorAll('[data-ox-compare-price]').forEach((node) => {
    node.textContent = option.dataset.compare || '';
    node.hidden = !option.dataset.compare;
  });
  section.querySelectorAll('[data-ox-atc]').forEach((button) => {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? (button.closest('.ox-mobile-buy') ? 'Добави' : 'Добави в количката') : 'Изчерпано';
  });
  const media = option.dataset.mediaId && section.querySelector(`[data-media-id="${CSS.escape(option.dataset.mediaId)}"]`);
  media?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
  oxTrack('ox_variant_selected', { variant_id: option.value, title: option.textContent.trim() });
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-ox-cart-form]');
  if (!form || !window.fetch) return;
  event.preventDefault();

  const button = form.querySelector('[data-ox-atc]');
  const status = form.querySelector('[data-ox-cart-status]');
  if (!button || button.disabled) return;
  const initialText = button.textContent;
  button.disabled = true;
  button.textContent = 'Добавяме…';
  if (status) status.textContent = 'Добавяме продукта в количката.';
  oxTrack('ox_add_to_cart_attempt', { variant_id: form.elements.id?.value || null });

  try {
    const endpoint = `${form.action.replace(/\/$/, '')}.js`;
    const formData = new FormData(form);
    formData.set('sections', 'cart-drawer-section');
    formData.set('sections_url', window.location.pathname);
    const response = await fetch(endpoint, { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || payload.message || 'Продуктът не беше добавен.');
    if (status) status.textContent = 'Продуктът е добавен. Отваряме количката.';
    oxTrack('ox_add_to_cart', { product_id: payload.product_id || null, variant_id: payload.variant_id || payload.id || null, quantity: payload.quantity || 1 });
    const renderedDrawer = payload.sections?.['cart-drawer-section'];
    const drawerSection = document.getElementById('shopify-section-cart-drawer-section');
    if (renderedDrawer && drawerSection) {
      const parsed = new DOMParser().parseFromString(renderedDrawer, 'text/html');
      const replacement = parsed.getElementById('shopify-section-cart-drawer-section');
      drawerSection.innerHTML = replacement?.innerHTML || renderedDrawer;
      requestAnimationFrame(() => document.getElementById('cart-drawer')?.open?.());
    } else if (form.dataset.oxRedirect !== 'false') {
      window.setTimeout(() => window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`), 250);
    }
  } catch (error) {
    if (status) status.textContent = error.message || 'Възникна грешка. Опитай отново.';
    button.disabled = false;
    button.textContent = initialText;
  }
});

document.addEventListener('click', (event) => {
  const target = event.target.closest('[data-ox-track]');
  if (target) {
    const detail = { label: target.dataset.oxTrack, destination: target.getAttribute('href') || null };
    oxTrack('ox_cta_click', detail);
    if (target.dataset.oxModel) oxTrack('ox_model_selected', { model: target.dataset.oxModel });
  }

  const checkout = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
  if (checkout) oxTrack('ox_checkout_started', { source: window.location.pathname });
});

document.addEventListener('play', (event) => {
  if (event.target.matches('[data-ox-proof-video]') && !event.target.dataset.oxTracked) {
    event.target.dataset.oxTracked = 'true';
    oxTrack('ox_raw_proof_play', { source: event.target.currentSrc || null });
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ox-gallery]').forEach((gallery) => new OchilaGallery(gallery));

  const revealTargets = document.querySelectorAll('.ox-quick-summary__grid article,.ox-how-it-works li,.ox-choice-cards article,.ox-final-product-cta__grid');
  if (revealTargets.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealTargets.forEach((target) => target.classList.add('ox-reveal'));
    document.documentElement.classList.add('ox-reveal-ready');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.forEach((target) => revealObserver.observe(target));
  }

  const viewItem = document.querySelector('[data-ox-view-item]');
  if (viewItem) {
    try { oxTrack('ox_view_item', JSON.parse(viewItem.textContent)); } catch (_error) { /* Ignore malformed optional context. */ }
  }
  if (/\/cart\/?$/.test(window.location.pathname)) oxTrack('ox_view_cart', {});

  document.querySelectorAll('[data-ox-product-section]').forEach((section) => {
    const mainButton = section.querySelector('.ox-product__buy [data-ox-atc]');
    const stickyBar = section.querySelector('.ox-mobile-buy');
    if (!mainButton || !stickyBar || !('IntersectionObserver' in window)) return;
    let hasSeenMainButton = false;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) hasSeenMainButton = true;
      stickyBar.classList.toggle('is-visible', hasSeenMainButton && !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0.15 });
    observer.observe(mainButton);
  });
});
